import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import {formatCurrency, formatRate} from "./CoreFunctions";


const RevolversHelocPage = () => {
    const [helocs, setHelocs] = useState([]);
    const [loading, setLoading] = useState(true); // Manage loading state

    useEffect(() => {
        // Fetch the heloc data from the API
        axios.get('/api/balance_sheet/financing/revolvers/helocs/')
            .then(response => {
                console.log(response.data); // Log the response data for debugging
                setHelocs(response.data); // Populate the component state
                setLoading(false); // Stop loading
            })
            .catch(error => {
                console.error('Error fetching heloc data:', error);
                setLoading(false); // Stop loading even on error
            });
    }, []); // Empty dependency array ensures this runs only on mount

    // Loading message while fetching data
    if (loading) {
        return <div>Loading HELOCs...</div>;
    }

    const handleRemove = async (id) => {
        try {
            await axios.delete(`/api/balance_sheet/financing/revolvers/helocs/${id}/`); // Call DELETE API
            // Update state to remove the deleted heloc
            setHelocs((prevHelocs) => prevHelocs.filter(heloc => heloc.id !== id));
            alert("Loan removed successfully");
        } catch (error) {
            console.error("Error removing loan:", error);
            alert("There was an error removing the loan.");
        }
    };

    // Helper function to format currency
    // const formatCurrency = (amount) => {
    //     return `$${Math.round(amount).toLocaleString()}`;
    // };

    // Helper to build asset detail URL from loan + asset_info
    const buildAssetUrl = (loanObj) => {
        if (!loanObj || !loanObj.asset_info || !loanObj.asset_info.id) return null;
        const assetInfo = loanObj.asset_info;
        const id = assetInfo.id;
        let type2 = assetInfo.type_2 || assetInfo.type2 || assetInfo.asset_type_2;
        // Infer from loan type if backend omitted type_2
        if (!type2 && loanObj.revolver_type === 'heloc') {
            type2 = 'resi_property';
        }
        switch (type2) {
            case 'vehicle':
                return `/balance_sheet/assets/physical_assets/vehicles/${id}`;
            case 'resi_property':
                return `/balance_sheet/assets/physical_assets/resi_properties/${id}`;
            default:
                return null;
        }
    };

    return (
        <div style={{ marginLeft: '40px' }}>
            <h1>HELOCs</h1>
            <div style={{ marginBottom: '20px' }}>
                <Link to="/balance_sheet/financing/create-loan/">
                    <button type="button" className="btn btn-primary" style={{ backgroundColor: '#007bff', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '4px' }}>Create New HELOC</button>
                </Link>
            </div>
            <table className="heloc-table">
                <thead>
                    <tr>
                        <th>Loan ID</th>
                        <th>Lender</th>
                        <th>Loan or Line Amount</th>
                        <th>Rate Type</th>
                        <th>Current Rate</th>
                        <th>Outstanding Amt.</th>
                        <th>% Outstanding</th>
                        <th>Principal Paid</th>
                        <th>Interest Paid To-Date</th>
                        <th>Interest Paid % of Loan Amt.</th>
                        <th>Total Closing Costs & Fees Paid</th>
                        <th>Total Cost of Loan (To-Date)</th>
                        <th>Total Cost of Loan (To-Date) % of Loan Amt.</th>
                        <th>Linked Asset</th>
                        <th>Maturity Date</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {helocs.length > 0 ? (
                        helocs.map(heloc => (
                            <tr key={heloc.id}>
                                <td>
                                    <Link to={`/balance_sheet/financing/revolvers/helocs/${heloc.id}`}>{heloc.id}</Link>
                                </td>
                                <td>{heloc.lender_name || heloc.lender}</td>
                                <td>{formatCurrency(heloc.current_credit_limit)}</td>
                                <td>Floating</td>
                                <td>{formatRate(heloc.current_rate, 2)}</td>
                                <td>{formatCurrency(heloc.current_outstanding)}</td>
                                <td>{formatRate(heloc.percent_outstanding, 2)}</td>
                                <td>n/a</td>
                                <td>{formatCurrency(heloc.interest_paid_to_date)}</td>
                                <td>{formatRate(heloc.interest_paid_as_perc_of_loan_amt, 2)}</td>
                                <td>{formatCurrency(heloc.fees_paid_to_date)}</td>
                                <td style={{ color: '#f87171' }}>{formatCurrency(heloc.total_cost_paid_to_date)}</td>
                                <td>{formatRate(heloc.total_cost_paid_as_perc_of_loan_amt, 2)}</td>
                                <td>
                                    {(() => {
                                        const url = buildAssetUrl(heloc);
                                        const label = heloc.asset_info?.description;
                                        return (url && label) ? (
                                            <Link to={url}>{label}</Link>
                                        ) : (
                                            <span></span>
                                        );
                                    })()}
                                </td>
                                <td>{heloc.maturity_date || 'n/a'}</td>
                                <td>
                                    <button type="button" className="btn btn-danger" onClick={() => handleRemove(heloc.id)}>Remove</button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="16" style={{ textAlign: 'center' }}>No helocs found.</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <style jsx>{`
                .heloc-table {
                    margin: 20px;
                    width: 90%;
                    table-layout: auto;
                    border-collapse: collapse;
                }
                .heloc-table th, .heloc-table td {
                    border: 1px solid #ccc;
                    padding: 10px;
                    text-align: left;
                }
                .heloc-table th {
                    background-color: #f0f0f0;
                }
                button {
                    background-color: #ff4d4d;
                    color: white;
                    border: none;
                    padding: 5px 10px;
                    cursor: pointer;
                }
                button:hover {
                    background-color: #ff0000;
                }
            `}</style>
        </div>
    );
};

export default RevolversHelocPage;